import IncludePropertyInEvents from "../../../../contents/docs/integrate/feature-flags-code/_snippets/include-feature-flag-property-in-backend-events.mdx";
import DotNetSetSendFeatureFlagsTrue from "../../../../contents/docs/integrate/feature-flags-code/_snippets/feature-flags-code-dotnet-set-send-feature-flags-to-true.mdx";
import DotNetOverrideServerProperties from "../../../../contents/docs/integrate/feature-flags-code/_snippets/override-server-properties/dotnet.mdx";
import * as React from 'react';
export default {
  IncludePropertyInEvents,
  DotNetSetSendFeatureFlagsTrue,
  DotNetOverrideServerProperties,
  React
};